// Material
export const MATERIAL_UNTITLED_SECTION = 'Untitled section';

export const ORDER_BIG_DP_PRECISION = 100;
export const MAX_ORDER_UPPER_BOUND =
  '9.9999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999';
